export const cardiac = (() => {
    const placeHolderText = 'No Chest pain, palpitations, edema.'

    return placeHolderText
})